module.exports = __webpack_public_path__ + "img/chaxun.9a1ec2d3.png";